import { type FormikProps, useFormik } from "formik";
import React, { forwardRef, useImperativeHandle } from "react";
import { useFragment } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { videoSourceForm_Vimeo_VimeoVideoSourceFragment$key } from "@relay/videoSourceForm_Vimeo_VimeoVideoSourceFragment.graphql";
import { getVideoSourceFormSchema } from "./video-source-form.consts";
import { VIMEO_VIMEO_VIDEO_SOURCE_FRAGMENT } from "./video-source-form.graphql";
import { VideoSourceFormProps, VideoSourceFormState } from "./video-source-form.types";
import { DefaultTextFieldComponent } from "../../../../components/DefaultTextInput";
import { ValidatedField } from "../../../../components/ValidatedField";

export const VideoSourceForm = forwardRef<FormikProps<VideoSourceFormState>, VideoSourceFormProps>(
	function VideoSourceForm({ onSubmit, videoSourceFragmentRef, isCreating = false }, ref) {
		const { t } = useTranslation("common");
		const videoSource = useFragment<videoSourceForm_Vimeo_VimeoVideoSourceFragment$key>(
			VIMEO_VIMEO_VIDEO_SOURCE_FRAGMENT,
			videoSourceFragmentRef ?? null,
		);

		const initialValues: VideoSourceFormState = {
			name: videoSource?.name ?? "",
			accessToken: "",
		};

		const formik = useFormik<VideoSourceFormState>({
			initialValues,
			validationSchema: getVideoSourceFormSchema(isCreating),
			onSubmit,
		});

		useImperativeHandle(ref, () => ({
			...formik,
		}));

		return (
			<form onSubmit={formik.handleSubmit}>
				<ValidatedField<VideoSourceFormState, string>
					name={"name"}
					label={t("table.name")}
					required={true}
					component={DefaultTextFieldComponent}
					formikConfig={formik}
				/>
				{isCreating && (
					<ValidatedField<VideoSourceFormState, string>
						name={"accessToken"}
						label={t("videoSources.accessTokenLabel")}
						required={true}
						component={DefaultTextFieldComponent}
						formikConfig={formik}
					/>
				)}
			</form>
		);
	},
);
